import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SubscriptionSuccessModal from './SubscriptionSuccessModal';

const clearSubscriptionSuccessQueryParams = (pathname) => {
	const url = new URL(window.location);
	const params = new URLSearchParams(url.search);

	if (!params.has('subscription_success')) return;

	params.delete('subscription_success');
	params.delete('plan_name');

	const newUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname;
	window.history.replaceState({}, '', newUrl);
};

export default function AuthenticatedSubscriptionSuccessModal() {
	const [isOpen, setIsOpen] = useState(false);
	const [planName, setPlanName] = useState('');
	const location = useLocation();
	const { authenticated, loading } = useAuth();

	useEffect(() => {
		if (loading || !authenticated) {
			setIsOpen(false);
			return;
		}

		const params = new URLSearchParams(location.search);
		if (params.get('subscription_success') === 'true') {
			setPlanName(params.get('plan_name') || '');
			setIsOpen(true);
		}
	}, [location.search, authenticated, loading]);

	const handleClose = () => {
		setIsOpen(false);
		clearSubscriptionSuccessQueryParams(location.pathname);
	};

	return (
		<SubscriptionSuccessModal isOpen={isOpen} onClose={handleClose} planName={planName} />
	);
}
